import styled from "styled-components";

export const LeftArrow = styled.img.attrs((props) => ({
  src: "/bradescoprime/assets/chevron-darkblue-left.svg",
}))`
  position: absolute;
  width: 32px;
  height: 32px;
  left: 5%;
  top: 126px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  outline: none;
  z-index: 1;
  display: ${({ disabled }) => (disabled ? "none" : "flex")};

  @media (max-width: 767px) {
    left: calc(50vw - 160px);
  }
`;

export const RightArrow = styled.img.attrs((props) => ({
  src: "/bradescoprime/assets/chevron-darkblue-right.svg",
}))`
  position: absolute;
  width: 32px;
  height: 32px;
  right: 5%;
  top: 126px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  outline: none;
  z-index: 1;
  display: ${({ disabled }) => (disabled ? "none" : "flex")};

  @media (max-width: 767px) {
    right: calc(50vw - 160px);
  }
`;
